export const scheduleTypes = {
  LOAD: 0,
  UNLOAD: 1,
};

export const scheduleTypesToLabel = {
  [scheduleTypes.LOAD]: 'Carga',
  [scheduleTypes.UNLOAD]: 'Descarga',
  LOAD: 0,
  UNLOAD_RETURN: 1,
  UNLOAD_DELIVERY: 2,
};

export const scheduleStatus = {
  SCHEDULED: 0,
  CANCELLED: 1,
};

export const scheduleStatusToLabel = {
  [scheduleStatus.SCHEDULED]: 'Agendado',
  [scheduleStatus.CANCELLED]: 'Cancelado',
};

export const unloadTypes = {
  UNLOAD_RETURN: 1,
  UNLOAD_DELIVERY: 2,
};

export const unloadTypesToLabel = {
  [unloadTypes.UNLOAD_DELIVERY]: 'Entrega',
  [unloadTypes.UNLOAD_RETURN]: 'Devolução',
};
